import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "chatbot-interface flex flex-col h-full bg-white rounded-lg overflow-hidden relative" }
const _hoisted_2 = { class: "flex items-start" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "animate-pulse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatbotHeader = _resolveComponent("ChatbotHeader")!
  const _component_ChatbotMessages = _resolveComponent("ChatbotMessages")!
  const _component_ChatbotInput = _resolveComponent("ChatbotInput")!
  const _component_ChatHistoryList = _resolveComponent("ChatHistoryList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ChatbotHeader, {
      businessRole: _ctx.userData?.business_role,
      environment: _ctx.environment,
      userName: _ctx.userData?.name,
      userAvatar: _ctx.userAvatarForHeader,
      onToggleHistory: _ctx.toggleChatHistory
    }, null, 8, ["businessRole", "environment", "userName", "userAvatar", "onToggleHistory"]),
    (_ctx.isFastmodeActive && !_ctx.isFastModeBannerDismissed)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["bg-yellow-50 border-l-4 border-yellow-400 p-4 relative", { 'filter blur-sm': _ctx.isChatHistoryOpen }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"flex-shrink-0\" data-v-2cfce0ad><svg class=\"h-5 w-5 text-yellow-400\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"currentColor\" data-v-2cfce0ad><path fill-rule=\"evenodd\" d=\"M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z\" clip-rule=\"evenodd\" data-v-2cfce0ad></path></svg></div><div class=\"ml-3 flex-1\" data-v-2cfce0ad><p class=\"text-sm text-yellow-700\" data-v-2cfce0ad> Financial data is only accessible in DeepMode. Please switch modes if you need financial information. </p></div>", 2)),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissFastModeBanner && _ctx.dismissFastModeBanner(...args))),
              class: "ml-auto flex-shrink-0 text-yellow-400 hover:text-yellow-500 focus:outline-none"
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                class: "h-5 w-5",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                  "clip-rule": "evenodd"
                })
              ], -1)
            ]))
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["flex-1 relative overflow-hidden", { 'filter blur-sm': _ctx.isChatHistoryOpen }])
    }, [
      _createVNode(_component_ChatbotMessages, {
        messages: _ctx.messages,
        userData: _ctx.userData,
        class: "absolute inset-0"
      }, null, 8, ["messages", "userData"])
    ], 2),
    (_ctx.isInitialLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["flex justify-center items-center py-3 bg-blue-50 text-blue-600 text-sm", { 'filter blur-sm': _ctx.isChatHistoryOpen }])
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "flex items-center" }, [
            _createElementVNode("span", { class: "animate-pulse" }, "Initialisierung")
          ], -1)
        ]), 2))
      : _createCommentVNode("", true),
    (_ctx.isResponseLoading && !_ctx.isInitialLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["flex justify-center items-center py-3 bg-blue-50 text-blue-600 text-sm", { 'filter blur-sm': _ctx.isChatHistoryOpen }])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentLoadingMessage), 1)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["bg-red-50 text-red-600 p-2 text-sm text-center", { 'filter blur-sm': _ctx.isChatHistoryOpen }])
        }, _toDisplayString(_ctx.error), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({ 'filter blur-sm': _ctx.isChatHistoryOpen })
    }, [
      _createVNode(_component_ChatbotInput, {
        onSendMessage: _ctx.handleSendMessage,
        onModeChanged: _ctx.handleModeChanged,
        disabled: _ctx.isInitialLoading || _ctx.isResponseLoading || _ctx.isChatHistoryOpen
      }, null, 8, ["onSendMessage", "onModeChanged", "disabled"])
    ], 2),
    (_ctx.isChatHistoryOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "absolute inset-0 bg-black bg-opacity-30 z-40",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeChatHistory && _ctx.closeChatHistory(...args)))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ChatHistoryList, {
      isOpen: _ctx.isChatHistoryOpen,
      userChats: _ctx.userChats,
      currentChatId: _ctx.currentChat?.id || '',
      onClose: _ctx.closeChatHistory,
      onSelectChat: _ctx.handleSelectChat,
      onDeleteChat: _ctx.handleDeleteChat,
      onCreateNewChat: _ctx.handleCreateNewChat,
      class: "z-50"
    }, null, 8, ["isOpen", "userChats", "currentChatId", "onClose", "onSelectChat", "onDeleteChat", "onCreateNewChat"])
  ]))
}